export default "tender-header-title = Просмотр Тендера\ntender-header-title-response = Ответ на заявку"